export const getBySlug = () =>
  groq`*[_type == 'pages' && slug.current == $slug][0]{...}`

export const getById = () => groq`*[_type == 'pages' && _id == $id][0]{...}`
